import React, { useEffect, useState } from 'react';
import StepContent from '../../components/step-content';
import { Row, Column, StructuredListSkeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow, DataTable, Button, TableToolbar, TableToolbarContent } from 'carbon-components-react';
import {Edit16, TrashCan16, Add16 } from '@carbon/icons-react';
import DependentEdit from './dependent-edit';
import confirm from '../../forms/confirm';
import Header from '../../components/header';
import { formatDate, maskSSN } from '../../components/formatters';
import Card from '../../components/card';
import DescriptionDetails from '../../components/description-details';
import { useDispatch, useSelector } from 'react-redux';
import useMsalApi from '../../components/use-msal-api';
import { buildDependents } from '../../components/contact-builder';
import { deleteDependent} from '../../redux/actions/enrollments-actions';
import { format, parseISO } from 'date-fns';

const Dependents = ({pageStep}) => {
    const [dependents, setDependents] = useState([]);
    const [show, setShow] = useState();
    const [loading, setLoading] = useState(true);
    const [dependent, setDependent] = useState();
    const enrollments = useSelector(s => s.enrollments);
    const [callApi] = useMsalApi();
    const dispatch = useDispatch();
  
    const headers = [
        {key: "name", header: "Name"},
        {key: "relationship", header: "Relationship"}, 
        {key: "ssn", header: "SSN"},
        {key: "birthdate", header: "Date of Birth"},
        {key: "gender", header: "Gender"},
    ];

    const confirmDelete = async(currentContact) => {
        const result = await confirm(`Are you sure you want to remove ${currentContact.firstName} ${currentContact.lastName} as a dependent?`, {title: "Remove Dependent", buttonText: "REMOVE"});
        if(result){
            const results = await callApi(`Enrollments/${enrollments.id}/dependent/${enrollments.employee.id}/${currentContact.id}/${format(
                parseISO(enrollments.effectiveDate),
                "yyyy-MM-dd"
              )}`, "DELETE");
            if(!results.error){
                dispatch(deleteDependent(currentContact.id));
            }
        }
    }

    const links = (currentDependent) => {
        return(<>
            <Button hasIconOnly iconDescription={`Edit ${currentDependent.firstName}`} kind="ghost" size="sm" onClick={() => {setDependent(currentDependent); setShow(true)}}>
                <Edit16 />
            </Button>
            <Button hasIconOnly iconDescription={`Remove ${currentDependent.firstName}`} kind="ghost" size="sm" onClick={() => {confirmDelete(currentDependent)}}>
                <TrashCan16 />
            </Button>
        </>);
    }
        
    useEffect(() => {
        let ctrl = new AbortController();
        if(!Array.isArray(enrollments)){
            setDependents(buildDependents(enrollments));
            setLoading(false);
        }
        return () => ctrl?.abort();
    }, [enrollments]);

    const onSubmit = async (formData) => {
        console.log(formData);
      };
    return ( 
        <>
        <StepContent pageStep={pageStep} onSubmit={onSubmit} >
            <Header title="Dependents"  />
            {loading ?
                <div className="my-8">
                <StructuredListSkeleton />
                </div>
                :

            <Row>
                <Column sm={{span: 0}} md={{span: 8}} className="p-0">
                    <DataTable headers={headers} rows={[]} >
                        {() => (
                            <TableContainer>
                                <Table>
                                    <TableHead >
                                        <TableRow >
                                            {headers.map((header, idx) => (
                                                <TableHeader key={idx} className="p-4">
                                                    {header.header}
                                                </TableHeader>
                                            ))}
                                            <TableHeader></TableHeader>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                        dependents.map((dependent, idx) =>
                                            <TableRow key={idx}>
                                                <TableCell className='p-4'>{dependent.firstName + " " + dependent.lastName}</TableCell>
                                                <TableCell className='p-4'> {dependent.relationship?.name}</TableCell>
                                                <TableCell className='p-4'>{dependent.relationship?.name === "Employee" ? <>********</> : <>{maskSSN(dependent.ssn)}</>}</TableCell>
                                                <TableCell className='p-4'>{dependent.relationship?.name === "Employee" ? <>********</> : <>{formatDate(dependent.birthdate)}</>}</TableCell>
                                                <TableCell className='p-4'>{dependent.gender?.name}</TableCell>
                                                {dependent.courtOrdered ? <TableCell></TableCell> : <TableCell >{links(dependent)} </TableCell>}         
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                                {dependents.length === 0 && <h6 className='text-center py-12'>There are no dependents listed</h6> }
                            </TableContainer>
                        )}
                    </DataTable>
                    <Button kind='ghost' renderIcon={Add16} onClick={() => {setDependent({}); setShow(true)}}>Add Dependent</Button>

                </Column>
                <Column md={{span:0}}>
                    <DataTable headers={headers} rows={[]} >
                        {() => (
                            <TableContainer>
                                {dependents.length === 0 && <h6 className='text-center py-12'>There are no dependents listed</h6> }
                            </TableContainer>
                        )}
                    </DataTable>

                    {dependents.map((dependent) => 
                        <Card key={dependent.id} title={
                        <div className='grid grid-cols-2 gap-4 place-items-center'>
                            <div  className='justify-self-start'>{`${dependent.firstName} ${dependent.lastName}`}</div>
                            <span className='justify-self-end'>
                                {links(dependent)}
                            </span>
                        </div>
                    }>
                            <DescriptionDetails term="Relationship" definition={dependent.relationship.name} />
                            <DescriptionDetails term="Social Security Number" definition={maskSSN(dependent.ssn)} />
                            <DescriptionDetails term="Date of Birth" definition={formatDate(dependent.birthdate)} />
                        </Card>
                    )}
                    <Button kind='ghost' renderIcon={Add16} onClick={() => {setDependent({}); setShow(true)}}>Add Dependent</Button>

                </Column>
            </Row>
            }
        </StepContent>
        <DependentEdit dependent={dependent} setDependent={setDependent} show={show} setShow={setShow} dependents={dependents} setDependents={setDependents} />
        </>
     );
}
 
export default Dependents;